module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feedItem panel bg-lightest black"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'calendar'
      }
    }
  }, [(_vm.isLoadingEvents) ? _c('div', {
    staticClass: "px-0 py-5 w-100 font-weight-600 medium d-flex align-items-end justify-content-center"
  }, [_c('div', {
    staticClass: "fs-large mr-1"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('loader', {
    attrs: {
      "size": "small"
    }
  })], 1) : (_vm.rows.length > 0) ? _c('div', {
    staticClass: "px-0 pt-4 d-flex h-100"
  }, [_c('list', {
    staticClass: "w-100",
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.rows,
      "actions": _vm.actions
    }
  })], 1) : _c('div', {
    staticClass: "px-0 py-5 w-100 text-center font-weight-600 medium fs-larger"
  }, [_vm._v("\n\t\t\tNo data\n\t\t")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-weight-600"
  }, [_c('span', {
    staticClass: "ml-1"
  }, [_vm._v("Next Departures")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70461844"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/FeedcardDepartures.vue
// module id = 2163
// module chunks = 0